import React, { useCallback } from 'react'
import { Flex, List, Popup, Text } from '@leverege/ui-elements'

import S from './ClientIdItem.css'

export default function ClientIdItem( props ) {
  const { item, onEvent, clientIdsApi, ...rest } = props

  const onClick = useCallback( () => {
    onEvent( { data : 'click', value : item } )
  }, [ onEvent, item ] )

  return (
    <List.Item
      className={S.item}
      eventData="test"
      onEvent={onClick}
      item={item}
      {...rest}>
      <Flex variant="rowSpaceBetween" align="center">
        <Flex variant="colM">
          <Text variant="listItemTitle">{item.alias}</Text>
          <Text variant="listItemSubtitle" style={{ textAlign : 'right', flex : 1 }}>
            {item.authorizationUri}
          </Text>
        </Flex>
      </Flex>
    </List.Item>
  )
}
